import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pause\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 17C10 18.1 9.1 19 8 19C6.9 19 6 18.1 6 17V7C6 5.9 6.9 5 8 5C9.1 5 10 5.9 10 7V17ZM14 17V7C14 5.9 14.9 5 16 5C17.1 5 18 5.9 18 7V17C18 18.1 17.1 19 16 19C14.9 19 14 18.1 14 17Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/pause.svg
// module id = qi2b
// module chunks = 13